/* eslint-disable react/no-array-index-key */
import {
  Skeleton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import React from 'react';

import ReportTemplateIconEmptyReport from '../../assets/report-template-icon-empty-report.svg';
import { getColumnLabelById } from '../../constants/reportTemplateColumnList';
import { useReportingHubContext } from './useReportingHubContext';

function SectionsPreview() {
  const { activeSheet } = useReportingHubContext();

  if (!activeSheet?.reportSections?.length) {
    return (
      <Stack py={14} alignItems="center" textAlign="center" spacing={1}>
        <img src={ReportTemplateIconEmptyReport} alt="Empty Report" />
        <Typography variant="h6">No sections have been added.</Typography>
        <Typography>
          You can add sections to &quot;{activeSheet?.sheetName}&quot; in the &quot;Configuration&quot; tab on the
          right.
        </Typography>
      </Stack>
    );
  }

  return (
    <Stack sx={{ overflowY: 'scroll' }} bgcolor="#f9f9f9" pb={14}>
      {activeSheet?.reportSections.map((section) => (
        <Stack pb={5} key={section.id}>
          <Stack sx={{ width: '100%' }}>
            <TableContainer sx={{ overflowX: 'scroll' }}>
              <Table>
                <TableHead>
                  <TableRow sx={{ bgcolor: '#BEDEA1' }}>
                    <TableCell colSpan={section.columns.length}>{section.sectionName}</TableCell>
                  </TableRow>
                  <TableRow sx={{ bgcolor: 'rgba(110, 174, 58, 0.08)' }}>
                    {section.columns.map((column) => (
                      <TableCell key={column}>
                        {(section.columnLabels && section.columnLabels[column]) || getColumnLabelById(column)}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {[...Array(3)].map((value, index) => (
                    <TableRow key={index}>
                      {section.columns.map((column) => (
                        <TableCell key={column}>
                          <Skeleton animation={false} variant="text" sx={{ fontSize: '1rem' }} />
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Stack>
        </Stack>
      ))}
    </Stack>
  );
}

export default SectionsPreview;
